// store.js
import Vue from 'vue'
import Vuex from 'vuex'
import actscrm from './actscrm/actscrm.js'

Vue.use(Vuex)

// 数据
let state = {
}

// 事件
let actions = {
}

// 改变
let mutations = {
}

// 获取
let getters = {
}

const store = new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules: {
    actscrm: actscrm
  }
})
export default store
